export default __webpack_public_path__ + "static/12_36-7bedeca81a549bdf1bab3834fd66c6f7.png";